import { render } from "./BasicLogo.vue?vue&type=template&id=084a8e65&scoped=true"
import script from "./BasicLogo.vue?vue&type=script&lang=js"
export * from "./BasicLogo.vue?vue&type=script&lang=js"

import "./BasicLogo.vue?vue&type=style&index=0&id=084a8e65&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-084a8e65"

export default script